export function getRandomValue() {
    var bytes = new Uint8Array(4);
    crypto.getRandomValues(bytes);
    return bytes;
}
